import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["children", "style", "className", "position"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useState, useCallback, useLayoutEffect, cloneElement, isValidElement, Children } from 'react';
import mergeRefs from 'react-merge-refs';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import { useResizeObserver } from '@rexlabs/react-hooks';
import { getTextFromChild, splitText } from './utils';
var defaultStyles = StyleSheet({
  container: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: function textOverflow(_ref) {
      var token = _ref.token;
      return token('text.truncate.textOverflow', 'ellipsis');
    },
    whiteSpace: 'nowrap',
    // Target children of this container so we can use our text
    // components like Body, Heading etc. as children
    '& > *': {
      overflow: 'hidden',
      textOverflow: function textOverflow(_ref2) {
        var token = _ref2.token;
        return token('text.truncate.textOverflow', 'ellipsis');
      },
      whiteSpace: 'nowrap'
    }
  },
  middle: {
    display: 'flex',
    flex: 1
  }
});
export function Truncate(_ref3) {
  var _containerRef$current, _containerRef$current2;

  var children = _ref3.children,
      style = _ref3.style,
      className = _ref3.className,
      _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? 'end' : _ref3$position,
      props = _objectWithoutProperties(_ref3, _excluded);

  var s = useStyles(defaultStyles);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      text = _useState2[0],
      setText = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showTooltip = _useState4[0],
      setShowTooltip = _useState4[1];

  var truncateMiddle = useCallback(function (target) {
    var _context;

    var text = getTextFromChild(children);
    var maxWidth = target.offsetWidth;

    var _splitText = splitText(text, maxWidth),
        start = _splitText.start,
        end = _splitText.end,
        maxTextWidth = _splitText.maxTextWidth;

    setText(maxTextWidth > target.offsetWidth ? _concatInstanceProperty(_context = "".concat(start, "...")).call(_context, end) : null);
  }, [children]);
  var containerRef = useResizeObserver(function (_ref4) {
    var target = _ref4.target;

    if (position === 'middle') {
      truncateMiddle(target);
    }

    setShowTooltip(target.offsetWidth < target.scrollWidth);
  }, [children, position]);
  useLayoutEffect(function () {
    if (position === 'middle') {
      truncateMiddle(containerRef.current);
    }
  }, [position, containerRef, truncateMiddle]);
  var title = showTooltip ? (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.textContent) !== null && _containerRef$current !== void 0 ? _containerRef$current : '' : '';
  return /*#__PURE__*/React.createElement("span", _extends({}, props, s.with('container', {
    middle: position === 'middle'
  })({
    style: style,
    className: className
  }), {
    // If the child of this component is a string then we
    // need to measure the width of this element, otherwise
    // if it's a react element we need to measure the width
    // of the child element itself so we pass the ref down
    ref: /*#__PURE__*/isValidElement(children) ? undefined : containerRef,
    title: title
  }), /*#__PURE__*/isValidElement(children) ? Children.only( /*#__PURE__*/cloneElement(children, {
    // @ts-ignore
    ref: mergeRefs([containerRef, children.ref]),
    children: text !== null && text !== void 0 ? text : children.props.children
  })) : text !== null && text !== void 0 ? text : children);
}